import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import axios from "axios";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  ListGroup,
  Dropdown,
  Table,
  Offcanvas,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaChevronLeft, FaChevronRight, FaEdit, FaTrash } from "react-icons/fa";
import { BASE_URL, HEADERS } from "../../utils/constant";
import { toast } from "react-toastify";

const localizer = momentLocalizer(moment);
const API_URL = `${BASE_URL}/api/holidays/`;

const fixedColor = "#3B71CA";

const HolidayCalendar = () => {
  const [holidays, setHolidays] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [holidayName, setHolidayName] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [view, setView] = useState("monthly");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showPanel, setShowPanel] = useState(false);
  const userPermissions = localStorage.getItem("user_permissions") || "";

  useEffect(() => {
    fetchHolidays();
  }, []);

  const fetchHolidays = async () => {
    try {
      const response = await axios.get(API_URL, { headers: HEADERS });
      setHolidays(
        response.data.map((holiday) => ({
          ...holiday,
          color: "#BFD7ED",
          start: new Date(holiday.start),
          end: new Date(holiday.end),
        })),
      );
    } catch (error) {
      // console.error("Error fetching holidays:", error);
    }
  };

  const saveHoliday = async () => {
    if (!holidayName.trim()) {
      toast.error("Holiday name cannot be empty.");
      return;
    }

    try {
      if (editMode && selectedHoliday) {
        await axios.put(
          `${API_URL}${selectedHoliday.id}/`,
          { title: holidayName },
          { headers: HEADERS },
        );
        toast.success("Holiday updated successfully");
      } else {
        const newHoliday = {
          title: holidayName,
          start: moment(selectedDate).format("YYYY-MM-DD"),
          end: moment(selectedDate).format("YYYY-MM-DD"),
          color: fixedColor,
        };
        await axios.post(API_URL, newHoliday, { headers: HEADERS });
        toast.success("Holiday added successfully");
      }

      fetchHolidays();
      setShowModal(false);
      setShowPanel(false);
      setHolidayName("");
      setEditMode(false);
      setSelectedHoliday(null);
    } catch (error) {
      console.error("Error saving holiday:", error);
      toast.error("Failed to save holiday.");
    }
  };

  const deleteHoliday = async () => {
    try {
      await axios.delete(`${API_URL}${selectedHoliday.id}/`, {
        headers: HEADERS,
      });
      setHolidays(holidays.filter((h) => h.id !== selectedHoliday.id));
      toast.success("Holiday deleted successfully");
      setShowPanel(false);
    } catch (error) {
      console.error("Error deleting holiday:", error);
      toast.error("Failed to delete holiday.");
    }
  };

  const handleSelectSlot = ({ start }) => {
    if (userPermissions.includes("holidayscalender_add_holidayscalender")) {
      setSelectedDate(start);
      setHolidayName("");
      setEditMode(false);
      setSelectedHoliday(null);
      setShowPanel(true);
    }
  };

  const handleSelectEvent = (event) => {
    setSelectedHoliday(event);
    setHolidayName(event.title);
    setEditMode(true);
    setShowPanel(true);
  };

  const goToNextMonth = () =>
    setCurrentDate(moment(currentDate).add(1, "month").toDate());
  const goToPreviousMonth = () =>
    setCurrentDate(moment(currentDate).subtract(1, "month").toDate());

  return (
    <div className="container-fluid">
      <h4 className="mt-3 text-center mb-md-0">Holidays</h4>

      <div className="calendar-header d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
        {view === "monthly" ? (
          <div className="calendar-navigation d-flex align-items-center mb-2 mb-md-0">
            <Button
              variant="light"
              size="sm"
              onClick={goToPreviousMonth}
              style={{
                padding: "4px 8px",
                fontSize: "14px",
                borderRadius: "5px",
              }}
            >
              <FaChevronLeft />
            </Button>
            <h6
              className="mx-2 mb-0 text-dark"
              style={{ fontSize: "18px", fontWeight: "800" }}
            >
              {moment(currentDate).format("MMMM YYYY")}
            </h6>
            <Button
              variant="light"
              size="sm"
              onClick={goToNextMonth}
              style={{
                padding: "4px 8px",
                fontSize: "14px",
                borderRadius: "5px",
              }}
            >
              <FaChevronRight />
            </Button>
          </div>
        ) : (
          <div style={{ width: "150px" }}></div>
        )}
        <Dropdown>
          <Dropdown.Toggle
            variant="light"
            style={{
              backgroundColor: "#fff",
              border: "2px solid #ddd",
              color: "#444",
              fontWeight: "500",
              fontSize: "14px",
              padding: "4px 10px",
              borderRadius: "6px",
            }}
          >
            {view === "monthly" ? "📅 Calendar View" : "📋 List View"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setView("monthly")}>
              📅 Monthly View
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setView("list")}>
              📋 List View
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {view === "list" && (
        <Row>
          <Col md={12}>
            <div
              className={`table-responsive ${
                holidays.length === 0 ? "" : "tabell"
              } `}
            >
              <table className="table tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th>Date</th>
                    <th>Holiday Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {holidays.length > 0 ? (
                    holidays.map((holiday) => (
                      <tr key={holiday.id}>
                        <td>{moment(holiday.start).format("MMMM Do YYYY")}</td>
                        <td>{holiday.title}</td>
                        <td>
                          {userPermissions.includes(
                            "holidayscalender_change_holidayscalender",
                          ) && (
                            <>
                              <FaEdit
                                onClick={() => handleSelectEvent(holiday)}
                                style={{
                                  cursor: "pointer",
                                  color: "#007bff",
                                  marginRight: "10px",
                                }}
                              />
                              <FaTrash
                                onClick={() => {
                                  setSelectedHoliday(holiday);
                                  deleteHoliday();
                                }}
                                style={{ cursor: "pointer", color: "#dc3545" }}
                              />
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        className="text-center text-muted"
                        style={{ padding: "15px" }}
                      >
                        No holidays found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      )}
      {view === "monthly" && (
        <Calendar
          localizer={localizer}
          events={holidays}
          date={currentDate}
          style={{ height: "80vh", cursor: "pointer" }}
          selectable={true}
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleSelectEvent}
          views={["month"]}
          defaultView="month"
          popup
          eventPropGetter={(event) => ({
            style: {
              backgroundColor: event.color,
              color: "#1f7cff",
              borderRadius: "5px",
              padding: "3px",
              fontSize: "15px",
            },
          })}
        />
      )}
      <Offcanvas
        show={showPanel}
        onHide={() => {
          setShowPanel(false);
          setHolidayName("");
          setEditMode(false);
          setSelectedHoliday(null);
        }}
        placement="end"
      >
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title>
            {editMode ? "Edit Holiday" : "Add Holiday"}
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="p-2">
            <Form.Group className="mb-3">
              <Form.Label>Holiday Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter holiday name"
                value={holidayName}
                onChange={(e) => setHolidayName(e.target.value)}
              />
            </Form.Group>
            <p className="text-muted mb-4">
              <strong>Date:</strong>{" "}
              {moment(editMode ? selectedHoliday?.start : selectedDate).format(
                "MMMM Do YYYY",
              )}
            </p>
            <div className="d-flex gap-2">
              <Button variant="primary" onClick={saveHoliday}>
                {editMode ? "Update" : "Save"}
              </Button>

              {editMode && (
                <Button variant="danger" onClick={deleteHoliday}>
                  Delete
                </Button>
              )}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default HolidayCalendar;
